import { ReactNode } from 'react';

export const renderMessageWithCode = (template: string, configurationCode?: string): ReactNode => {
  const placeholder = '{code}';
  const placeholderIndex = template?.indexOf(placeholder);

  if (placeholderIndex === -1) return template;

  const before = template?.slice(0, placeholderIndex);
  const after = template?.slice(placeholderIndex + placeholder.length);

  return (
    <>
      {before}
      <span className="font-extrabold">{configurationCode}</span>
      {after}
    </>
  );
};
